import React, { Component, createRef } from "react";
import moment from "moment/moment";
// // Editable
import { withTranslation } from "react-i18next";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import { Card, Col, Container, Row } from "reactstrap";

import { Link } from "react-router-dom";
import { getMainStockInward, getStockInward, getStocksDashboard, baseUrl, getExpressDashboard } from "api";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";

class UserDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      editRowIndex: -1,
      inwordStockList: [],
      dashboardInfo: "",
      expressDataInfo:""
    };
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleShortcut);
  }
  async componentDidMount() {
    window.addEventListener("keydown", this.handleShortcut);
    const data = await getStockInward({ page: 1, limit: 5 });
    console.log('data',data);
    
    if (data && data.data) {
      this.setState({
        inwordStockList:
          data.data.jangads.length == 0
            ? [
                {
                  id: "0",
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : data.data.jangads,
      });
    }
    const dashboard = await getStocksDashboard();
    if (dashboard && dashboard.data) {
      this.setState({
        dashboardInfo: dashboard.data,
      });
    }
    const expressData = await getExpressDashboard();
    if (expressData && expressData.data) {
      this.setState({
        expressDataInfo: expressData.data,
      });
    }
  }
  handleShortcut = (e) => {
    if (e.shiftKey && e.key.toLowerCase() === "a") {
      e.preventDefault();
      this.openAddExpressModal();
    }
  };

  openAddExpressModal = () => {
    this.props.history.push("/user-add-express-inward");
  };
  render() {
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyName",
        text: `${this.props.t("Party Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.name;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          return row.pieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          return row.weight;
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.cycle;
        },
      },
      // {
      //   dataField: "createdAt",
      //   text:`${this.props.t('Inward Date')}`,
      //   formatter(cell, row) {
      //     return  moment(row.jangads.reduce((prev, current) => {
      //       return prev.cycle > current.cycle ? prev : current;
      //     }).createdAt).format("DD/MM/YYYY");
      //   },
      //   sort: true,
      // },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight == 0 ? (
            ""
          ) : (
            <>
              <div className="btn-group">
                <Link
                  to={{
                    pathname: "/user-add-stock-inward",
                    query: {
                      isEdit: 2,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded">
                    <img src="images/dashboard-images/edit.svg" />
                  </button>
                </Link>
              </div>
            </>
          ),
      },
    ];

    document.title = "sales office";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Row>
              <Breadcrumbs breadcrumbItem={this.props.t("Dashboard")} />
              <Col xxl={2} lg={3}>
                <div className="bg-light-purple position-relative main_hero_section main_hero_section_sub py-lg-5 py-0">
                  <Row className="ps-2">
                    <Col sm={8}>
                      <div className="pt-1">
                        <h3 className="text-black">
                          {this.props.t("Welcome Back")} !
                        </h3>
                      </div>
                    </Col>
                    <Col sm={4}>
                      <img
                        src={
                          JSON.parse(localStorage.getItem("authUser")).photo ==
                          null
                            ? "images/dashboard-images/welcome.svg"
                            : `${baseUrl}/uploads/${
                                JSON.parse(localStorage.getItem("authUser"))
                                  .photo
                              }`
                        }
                        className="img-fluid mt-3"
                        alt="welcome image"
                      />
                    </Col>
                    <p className="text-secondary">
                      {JSON.parse(localStorage.getItem("authUser")).name}
                    </p>
                  </Row>
                  <div className="bg-white main_hero_section_sub w-100 mt-2 absolute ms-0 py-4 px-2">
                    <h4 className="text-black">
                      {this.props.t("User Dashboard")}
                    </h4>
                    <Link to="/profile">
                      {" "}
                      <button className="main_hero_section_sub_btn mt-3">
                        View Profile{" "}
                        <i className="fa-solid fa-arrow-right-long"></i>
                      </button>
                    </Link>
                  </div>
                </div>
              </Col>
              {/* <Col xxl={2} lg={3}>
                <div className="bg-light-purple main_hero_section py-3 px-2">
                  <Row>
                    <Col sm={8}>
                      <div className="pt-4">
                        <h3 className="text-black">
                          {this.props.t("Welcome Back")}
                        </h3>
                      </div>
                    </Col>
                    <Col sm={4}>
                      <img
                        src={JSON.parse(localStorage.getItem("authUser")).photo == null ? "images/dashboard-images/welcome.svg" : `${baseUrl}/uploads/${JSON.parse(localStorage.getItem("authUser")).photo}`}
                        className="img-fluid mt-3"
                        alt="welcome image"
                      />
                    </Col>
                    <p className="text-secondary">
                      {JSON.parse(localStorage.getItem("authUser")).name}
                    </p>
                  </Row>
                </div>
                <div className="bg-white main_hero_section_sub py-3 px-2">
                  <h4 className="text-black">
                    {this.props.t("User Dashboard")}
                  </h4>
                  <Link to="/profile">
                    {" "}
                    <button className="main_hero_section_sub_btn mt-3">
                      View Profile{" "}
                      <i className="fa-solid fa-arrow-right-long"></i>
                    </button>
                  </Link>
                </div>
              </Col> */}
              <Col xxl={10} lg={9}>
                <Row>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Daily Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.dailyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Daily Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.dailyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Weekly Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.weeklyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Weekly Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.weeklyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Monthly Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.monthlyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Monthly Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.monthlyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Yearly Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.yearlyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Yearly Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.dashboardInfo.yearlyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
             <Row className="mt-4">
                <Col xxl={2} lg={3}>
                              </Col>
                <Col xxl={10} lg={9}>
                <Row>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Daily Express Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.expressDataInfo.dailyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Daily Express Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.expressDataInfo.dailyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Weekly Express Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.expressDataInfo.weeklyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Weekly Express Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.expressDataInfo.weeklyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Monthly Express Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.expressDataInfo.monthlyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Monthly Express Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.expressDataInfo.monthlyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Yearly Express Inward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.expressDataInfo.yearlyInwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyinward.svg"
                            className="img-fluid"
                            alt="daily inward image"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                      <Row>
                        <Col sm={8} className="px-3">
                          <h5 className="pt-3 text-black fs-4">
                            {this.props.t("Yearly Express Outward")}
                          </h5>
                          <h3 className="pt-2 text-black">
                            {this.state.expressDataInfo.yearlyOutwards}
                          </h3>
                        </Col>
                        <Col sm={4}>
                          <img
                            src="images/dashboard-images/dailyoutward.svg"
                            className="img-fluid"
                            alt="daily outward image"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>
             </Row>
            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("STOCK INWARD")}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    data={this.state.inwordStockList}
                    columns={this.columns1}
                  />
                </div>
              </Card>
            </div>

            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("STOCK OUTWARD")}
                </h2>
              </div>
              {/* <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    expandRow={expandRow1}
                    data={this.state.inwordStockList}
                    columns={this.columns1}
                  />
                </div>
              </Card> */}
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(UserDashboard);
